import { __extends } from "tslib";
import { Injectable } from '@angular/core';
import { AwesomeCordovaNativePlugin, cordova } from '@awesome-cordova-plugins/core';
import { Observable } from 'rxjs';
import * as ɵngcc0 from '@angular/core';
var Shake = /** @class */ (function (_super) {
    __extends(Shake, _super);
    function Shake() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shake.prototype.startWatch = function (sensitivity) { return cordova(this, "startWatch", { "observable": true, "clearFunction": "stopWatch", "successIndex": 0, "errorIndex": 2 }, arguments); };
    Shake.pluginName = "Shake";
    Shake.plugin = "cordova-plugin-shake";
    Shake.pluginRef = "shake";
    Shake.repo = "https://github.com/leecrossley/cordova-plugin-shake";
    Shake.platforms = ["iOS"];
Shake.ɵfac = /*@__PURE__*/ function () { var ɵShake_BaseFactory; return function Shake_Factory(t) { return (ɵShake_BaseFactory || (ɵShake_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(Shake)))(t || Shake); }; }();
Shake.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Shake, factory: function (t) { return Shake.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Shake, [{
        type: Injectable
    }], null, null); })();
    return Shake;
}(AwesomeCordovaNativePlugin));
export { Shake };

